// extracted by mini-css-extract-plugin
export default {"CustomShimmer":"ShimmerEffect_CustomShimmer__P7-Rx","shimmerAnimation":"ShimmerEffect_shimmerAnimation__yX0ph"};